import { useTranslation } from 'react-i18next';
import { TbHome } from 'react-icons/tb';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
} from 'react-router';

import { PermissionsProvider } from '@cccom/auth/permissions';
import { AppList } from '@cccom/home/app-list';
import { CCErrorPage } from '@cccom/shared/ui';
import { SiteSelector } from '@cccom/sites';
import { AppLogoProps } from '@cccom/ui/src/components/custom/layout/AppLogo';
import { SidebarProps } from '@cccom/ui/src/components/custom/layout/CCSidebar';
import { SharedLayout } from '@cccom/ui/src/components/custom/layout/SharedLayout';

import { environment as env } from '../env';
import useAutoRedirect from './use-auto-redirect';

function HomeLayout() {
  const [t] = useTranslation();
  useAutoRedirect();

  const logo: AppLogoProps = {
    logoSrc: 'images/CClogo.svg',
    appName: '',
    homeUrl: '/',
  };

  const sidebar: SidebarProps<'HOME'> = {
    logoProps: logo,
    menuItems: [{ label: t('home.apps'), path: 'apps', icon: TbHome }],
    profileMenuChildren: null,
    profileMenuItems: [],
    showSettings: false,
  };

  return (
    <SharedLayout
      className="p-7"
      sidebar={sidebar}
      limitScreenSize={false}
      siteSelector={<SiteSelector />}
    >
      <Outlet />
    </SharedLayout>
  );
}

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <PermissionsProvider>
          <HomeLayout />
        </PermissionsProvider>
      }
      errorElement={<CCErrorPage type="PAGE_ERROR" />}
    >
      <Route path="" element={<Navigate to="/apps" replace />} />
      <Route path="apps" element={<AppList />} errorElement={<CCErrorPage />} />
      <Route path="*" element={<CCErrorPage type="404" />} />
    </Route>
  ),
  {
    basename: env.production ? env.APP?.path : '',
  }
);
